import { Flex, HStack, Icon, LucideIcon, Text, VStack } from '@skin-seoul/design-system';
import React, { useState } from 'react';
import StatsSection from './StatsSection';
import { Condition } from '@skin-seoul/utils';
import AIInsight from './AiInsight';
type AnalysisSummaryProps = {
  orgProductId?: number;
  altProductId?: number;
  isFetching: boolean;
};
const AnalysisSummary = ({
  orgProductId,
  altProductId,
  isFetching
}: AnalysisSummaryProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  return <>
      <HStack width="100%" gap={3} alignItems="center" justify="stretch" display={{
      base: 'none',
      desktop: 'flex'
    }} data-sentry-element="HStack" data-sentry-source-file="AnalysisSummary.tsx">
        <VStack flex={1} backgroundColor="neutral.50" borderRadius="12px" padding="12px 16px" gap={4} alignItems="start" data-sentry-element="VStack" data-sentry-source-file="AnalysisSummary.tsx">
          <Text textStyle="paragraph.medium" fontWeight="medium" color="neutral.800" data-sentry-element="Text" data-sentry-source-file="AnalysisSummary.tsx">
            Analysis Summary
          </Text>
          <Condition expression={isFetching} then={<AIInsight.Skeleton />} else={orgProductId && altProductId && <AIInsight orgProductId={orgProductId} altProductId={altProductId} isExpanded={true} />} data-sentry-element="Condition" data-sentry-source-file="AnalysisSummary.tsx" />
        </VStack>

        <Flex flex={1} height="100%" data-sentry-element="Flex" data-sentry-source-file="AnalysisSummary.tsx">
          <Condition expression={isFetching} then={<StatsSection.Skeleton />} else={orgProductId && altProductId && <StatsSection orgProductId={orgProductId} altProductId={altProductId} />} data-sentry-element="Condition" data-sentry-source-file="AnalysisSummary.tsx" />
        </Flex>
      </HStack>
      <Flex width="100%" height="100%" flex={1} display={{
      base: 'flex',
      mobile: 'none'
    }} data-sentry-element="Flex" data-sentry-source-file="AnalysisSummary.tsx">
        <Condition expression={isFetching} then={<StatsSection.Skeleton />} else={orgProductId && altProductId && <StatsSection orgProductId={orgProductId} altProductId={altProductId} />} data-sentry-element="Condition" data-sentry-source-file="AnalysisSummary.tsx" />
      </Flex>

      <VStack width="100%" backgroundColor="neutral.75" borderRadius="12px" padding={2} gap={4} display={{
      base: 'flex',
      desktop: 'none'
    }} data-sentry-element="VStack" data-sentry-source-file="AnalysisSummary.tsx">
        <VStack width="100%" gap={3} alignItems="start" data-sentry-element="VStack" data-sentry-source-file="AnalysisSummary.tsx">
          <HStack width="100%" justifyContent="space-between" alignItems="center" data-sentry-element="HStack" data-sentry-source-file="AnalysisSummary.tsx">
            <Text textStyle="paragraph.medium" fontWeight="medium" color="neutral.800" data-sentry-element="Text" data-sentry-source-file="AnalysisSummary.tsx">
              Analysis Summary
            </Text>
            {isTruncated && <Icon boxSize={5} color="neutral.600" cursor="pointer" onClick={() => setIsExpanded(!isExpanded)}>
                <LucideIcon name={isExpanded ? 'CircleMinus' : 'CirclePlus'} />
              </Icon>}
          </HStack>
          <Condition expression={isFetching} then={<AIInsight.Skeleton />} else={orgProductId && altProductId && <AIInsight orgProductId={orgProductId} altProductId={altProductId} isExpanded={isExpanded} onIsTruncatedChange={setIsTruncated} />} data-sentry-element="Condition" data-sentry-source-file="AnalysisSummary.tsx" />
        </VStack>

        <Flex width="100%" height="100%" flex={1} display={{
        base: 'none',
        mobile: 'flex'
      }} data-sentry-element="Flex" data-sentry-source-file="AnalysisSummary.tsx">
          <Condition expression={isFetching} then={<StatsSection.Skeleton />} else={orgProductId && altProductId && <StatsSection orgProductId={orgProductId} altProductId={altProductId} />} data-sentry-element="Condition" data-sentry-source-file="AnalysisSummary.tsx" />
        </Flex>
      </VStack>
    </>;
};
export default AnalysisSummary;